import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    onUploadDone(event) {
        event.preventDefault();

        const label = event.target.dataset.label;

        window.filestack_client.picker({
            onUploadDone: (data) => {
                const files = data.filesUploaded.map(file => {
                    return {...file, url: window.filestack_client.transform(file.handle)}
                })

                this.stimulate('ClaimsAttachmentFilePickerReflex#upload_file', files, label);
            },
            maxFiles: 10,
            fromSources: ['local_file_system']
        }).open();
    }

    // Toggles an existing (persisted) attachment as marked-for-deletion.
    // Flips the hidden _destroy input between "0" and "1" so the form submission
    // either keeps or soft-deletes the attachment via accepts_nested_attributes_for.
    toggleDelete(event) {
        event.preventDefault();

        const row = event.currentTarget.closest('[data-attachment-row]');
        const destroyInput = row.querySelector('[data-destroy-input]');
        const willDestroy = destroyInput.value !== '1';

        destroyInput.value = willDestroy ? '1' : '0';

        // Visual: dim + red border when marked for deletion
        row.classList.toggle('opacity-60', willDestroy);
        row.classList.toggle('border-red-300', willDestroy);

        // Visual: strikethrough on the filename
        const filenameEl = row.querySelector('[data-attachment-filename]');
        filenameEl?.classList.toggle('line-through', willDestroy);
        filenameEl?.classList.toggle('text-gray-400', willDestroy);

        // Icon swap: trash ↔ undo
        row.querySelector('[data-trash-icon]')?.classList.toggle('hidden', willDestroy);
        row.querySelector('[data-undo-icon]')?.classList.toggle('hidden', !willDestroy);

        // Accessibility label
        event.currentTarget.setAttribute(
            'aria-label',
            willDestroy ? 'Undo removal' : 'Remove attachment'
        );
    }

    // Removes a newly-uploaded (unsaved) attachment row entirely from the DOM.
    // Since it has never been persisted, there is nothing to tell the server —
    // the row (including its hidden form inputs) simply disappears before submit.
    removeNewAttachment(event) {
        event.preventDefault();
        event.currentTarget.closest('[data-attachment-row]')?.remove();
    }
}
